<template>
    <div>
        <section class="box-item">
            <h3 class="approve_title">{{ $t('FIELD.COMPANY.INFORMATION') }}</h3>
            <table class="approve_table">
                <colgroup>
                    <col width="270px" />
                    <col width="*" />
                    <col width="270px" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.ID') }}({{ $t('BUTTON.GLOBAL.EMAIL') }})</th>
                        <td>{{ data.email }}</td>
                        <th>{{ $t('FIELD.EUR.FIRST.NAME') }}</th>
                        <td>{{ data.contactFirstName }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.PROFILE.COMPANY.NAME') }}</th>
                        <td>{{ data.companyName }}</td>
                        <th>{{ $t('FIELD.EUR.LAST.NAME') }}</th>
                        <td>{{ data.contactLastName }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.COMPANY.REGISTRATION.NUMBER') }}</th>
                        <td>{{ data.companyRegNo }}</td>
                        <th>{{ $t('FIELD.CONTACT.PHONE.NUMBER') }}</th>
                        <td>{{ data.phoneNumber }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.EUR.COMP.ADDR') }}</th>
                        <td>{{ data.companyAddress }}</td>
                        <th v-if="'C480' === corpCd">{{ $t('FIELD.EUR.APE.CODES') }}</th>
                        <td v-if="'C480' === corpCd">{{ data.apeCodes }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.POSTAL.CODE') }}</th>
                        <td>{{ data.zipCode }}</td>
                        <th>{{ $t('FIELD.INSURANCE.POLICY') }}</th>
                        <td v-if="0 < parseInt(data.fileLength1)">
                            <a href="javascript:" class="link_attch" @click="downloadFile('1', data.fileName1)">
                                <span class="ico_attach"></span>{{ data.fileName1 }}
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.COMPANY.WEBSITE.ADDRESS') }}</th>
                        <td>{{ data.companyWebAddress }}</td>
                        <th>{{ $t('FIELD.COMPANY.REGISTRATION.FILE') }}</th>
                        <td v-if="0 < parseInt(data.fileLength2)">
                            <a href="javascript:" class="link_attch" @click="downloadFile('2', data.fileName2)">
                                <span class="ico_attach"></span>{{ data.fileName2 }}
                            </a>
                        </td>
                    </tr>
                    <tr></tr>
                </tbody>
            </table>
        </section>

        <section>
            <h3 class="approve_title">{{ $t('SUBTITLE.AUTHREQ.REQUEST') }}</h3>
            <table class="approve_table">
                <colgroup>
                    <col width="270px" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.REQUEST.DATE') }}</th>
                        <td>{{ data.REQ_DT }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.REQUEST.TYPE') }}</th>
                        <td>{{ data.REQ_TYPE_NM }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.REQUEST.MODEL.CODE') }}</th>
                        <td>{{ data.SELECT_MODEL_CODE }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.MAJOR.PRODUCT.CATEGORY') }}</th>
                        <td>{{ data.CATE_MAIN_NM }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.SUB.PRODUCT.CATEGORY') }}</th>
                        <td>{{ data.CATE_SUB_NM }}</td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.REQUESTED.CONTENTS') }}</th>
                        <td>{{ data.SEL_CNTNTS }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <div class="btn_wrap_full topLine">
            <a href="javascript:" class="btn_white" @click="goListBack">
                {{ $t('BUTTON.GLOBAL.LIST') }}
            </a>
            <div class="btn_right" v-if="btnShow()">
                <a href="javascript:" class="btn_red" @click="btnClick('Reject')">
                    {{ $t('BUTTON.GLOBAL.REJECT') }}
                </a>
                <a href="javascript:" class="btn_blue" @click="btnClick('Approve')">
                    {{ $t('BUTTON.APPROVAL.APPROVE') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import rejectPopup from '~vb/eur/admin/RejectPopup';

const handleChangeStatus = approvalId =>
    axios.get(`${SDLUtil.API_URL}/basis/approval/handleChangeStatus.skp?approvalId=${approvalId}`);
const getRequestList = reqSeq =>
    axios.post(`${SDLUtil.API_URL}/noauth/eur/getRequestList.skp`, qs.stringify({ reqSeq: reqSeq }), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
const handleCancel = approvalId =>
    axios.post(`${SDLUtil.API_URL}/basis/approval/handleCancel.skp`, qs.stringify({ approvalId: approvalId }), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
const saveReqArpProc = saveParams =>
    axios.post(`${SDLUtil.API_URL}/basis/eur/saveReqArpProc.skp`, qs.stringify(saveParams), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });

export default {
    name: 'requestManagerDetail',
    props: {
        params: {},
        data: { type: Object, default: {} },
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            loginNo: 'getLoginNo',
            menuParams: 'getParams',
            roles: 'getRoles',
        }),
    },
    data() {
        return {
            view: 'N',
            fileName1: '',
            fileName2: '',
        };
    },
    methods: {
        btnClick(v) {
            if ('Reject' === v) {
                SDLUtil.show(
                    rejectPopup,
                    {
                        forward: v,
                        rtnFunc: (arg1, arg2) => {
                            this.save(v, arg1, arg2);
                        },
                    },
                    {
                        width: '500px',
                        height: 'auto',
                    },
                );
            } else if ('Approve' === v) {
                this.save(v, '', '');
            }
        },
        save(v, commentCode, commentCodeName) {
            getRequestList(this.data.REQ_SEQ)
                .then(request => {
                    const data = request.data.result.rowData[0];

                    let saveParams = {
                        userEmail: data.USER_EMAIL,
                        reqSeq: data.REQ_SEQ,
                        bpNo: data.BP_NO,
                        approvalId: data.APPROVAL_ID,
                        aprFrstUser: data.APR_FRST_USER,
                        aprScndUser: data.APR_SCND_USER,
                        loginNo: this.loginNo,
                        opinion: 'SKP System Approval Progress.',
                        approvalType: v,
                        commentCode: commentCode,
                        commentCodeName: commentCodeName,
                    };

                    SDLUtil.showLoadingBar(true);
                    if (SDLUtil.isNull(saveParams.approvalId)) {
                        saveReqArpProc(saveParams)
                            .then(save => {
                                SDLUtil.showLoadingBar(false);
                                this.goListBack();
                            })
                            .catch(err => {
                                SDLUtil.showLoadingBar(false);
                                Vue.$log.error(err);
                                SDLUtil.errorAlert(err);
                            });
                    } else {
                        handleChangeStatus(saveParams.approvalId)
                            .then(change => {
                                getRequestList(saveParams.reqSeq)
                                    .then(resp => {
                                        let status = resp.data.result.rowData[0].STATUS;
                                        if (['03', '05', '07'].includes(status)) {
                                            this.view = 'N';
                                            SDLUtil.alert({
                                                title: 'TITLE.GLOBAL.POPUP.ALERT',
                                                msg: 'MESSAGE.EUR.KNOX.ALREADY',
                                                onOkEvt: () => {
                                                    this.goListBack();
                                                },
                                            });
                                        } else {
                                            saveParams.status = status;
                                            handleCancel(saveParams.approvalId)
                                                .then(cancel => {
                                                    saveReqArpProc(saveParams)
                                                        .then(save => {
                                                            SDLUtil.showLoadingBar(false);
                                                            this.goListBack();
                                                        })
                                                        .catch(err => {
                                                            SDLUtil.showLoadingBar(false);
                                                            Vue.$log.error(err);
                                                            SDLUtil.errorAlert(err);
                                                        });
                                                })
                                                .catch(err => {
                                                    SDLUtil.showLoadingBar(false);
                                                    Vue.$log.error(err);
                                                    SDLUtil.errorAlert(err);
                                                });
                                        }
                                    })
                                    .catch(err => {
                                        SDLUtil.showLoadingBar(false);
                                        Vue.$log.error(err);
                                        SDLUtil.errorAlert(err);
                                    });
                            })
                            .catch(err => {
                                SDLUtil.showLoadingBar(false);
                                Vue.$log.error(err);
                                SDLUtil.errorAlert(err);
                            });
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
        },
        btnShow() {
            console.log('test', this.menuParams, this.menuParams.creationYn);
            let result = false;
            if ('Y' === this.menuParams.creationYn && 'Y' === this.view) {
                result = true;
            }
            return result;
        },
        goListBack() {
            this.attachFileClear();
            EventBus.$emit('goRequestListBack', 1);
        },
        downloadFile(fileType, fileName) {
            if ('1' === fileType) {
                this.fileName1 = fileName;
            } else if ('2' === fileType) {
                this.fileName2 = fileName;
            } else {
                return false;
            }

            let url = `${SDLUtil.API_URL}/noauth/eur/getAttachFileInfo.skp`;
            let params = {
                fileType: fileType,
                bpNo: this.data.bpNo,
            };
            axios
                .post(url, qs.stringify(params))
                .then(resp => {
                    let downloadLink = document.createElement('a');
                    downloadLink.download = fileName;
                    downloadLink.target = '_blank';
                    downloadLink.href = resp.data.fileDownUrl;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
        attachFileClear() {
            let url = `${SDLUtil.API_URL}/noauth/eur/clearAttachFiles.skp`;
            let fileName = this.fileName1;
            if (!SDLUtil.isNull(this.fileName2)) {
                if (SDLUtil.isNull(fileName)) {
                    fileName = this.fileName2;
                } else {
                    fileName += ',' + this.fileName2;
                }
            }
            axios
                .post(url, qs.stringify({ fileNames: fileName }))
                .then(resp => {})
                .catch(err => {
                    SDLUtil.errorAlert(err);
                });
        },
    },
    mounted() {
        if (!['03', '05', '07'].includes(this.data.STATUS)) {
            this.view = 'Y';
        }
    },
    beforeDestroy() {
        this.attachFileClear();
    },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/admin/RequestManagerDetail.vue